<template>
    <model-add-form></model-add-form>
</template>


<script>

    import ModelAddForm from '../../add/representations/WizardForm'

    export default {

        components:{
            ModelAddForm,
        },

    }
</script>

